import React from "react";

const Shield = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-shield"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-shield"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="m11,0v23.94c-2.1-1.062-9-5.046-9-11.565v-7.225c0-1.293.828-2.441,2.056-2.848L11,0Zm8.944,2.302L13,0v24c2.207-.905,9-4.282,9-11.625v-7.225c0-1.293-.828-2.441-2.056-2.848Z" />
    </svg>
  );
};

export default Shield;
